import {Injectable, NgZone} from "@angular/core";
import {default as OneSignalPlugin, PushSubscriptionChangedState} from "onesignal-cordova-plugin";
import {Observable} from "rxjs";

@Injectable()
export class PushSubscription {
  constructor(private readonly ngZone: NgZone) {
  }

  onChange(): Observable<PushSubscriptionChangedState> {
    return this.ngZone.runOutsideAngular(() => new Observable<PushSubscriptionChangedState>((subscriber) => {
      const listener = (event: PushSubscriptionChangedState) => {
        this.ngZone.run(() => {
          subscriber.next(event);
        });
      };

      OneSignalPlugin.User.pushSubscription.addEventListener('change', listener);

      return () => {
        OneSignalPlugin.User.pushSubscription.removeEventListener('change', listener);
      };
    }));
  }

  /**
   * The readonly push subscription ID.
   */
  getIdAsync(): Promise<string | null> {
    return this.ngZone.runOutsideAngular(() => new Promise<string | null>((resolve, reject) => {
      OneSignalPlugin.User.pushSubscription.getIdAsync()
        .then(
          (result) => {
            this.ngZone.run(() => {
              resolve(result);
            });
          },
          (reason) => {
            this.ngZone.run(() => {
              reject(reason);
            });
          },
        );
    }));
  }

  /**
   * The readonly push token.
   */
  getTokenAsync(): Promise<string | null> {
    return this.ngZone.runOutsideAngular(() => new Promise<string | null>((resolve, reject) => {
      OneSignalPlugin.User.pushSubscription.getTokenAsync()
        .then(
          (result) => {
            this.ngZone.run(() => {
              resolve(result);
            });
          },
          (reason) => {
            this.ngZone.run(() => {
              reject(reason);
            });
          },
        );
    }));
  }

  /**
   * Gets a boolean value indicating whether the current user is opted in to push notifications.
   * This returns true when the app has notifications permission and optOut() is NOT called.
   * Note: Does not take into account the existence of the subscription ID and push token.
   * This boolean may return true but push notifications may still not be received by the user.
   */
  getOptedInAsync(): Promise<boolean> {
    return this.ngZone.runOutsideAngular(() => new Promise<boolean>((resolve, reject) => {
      OneSignalPlugin.User.pushSubscription.getOptedInAsync()
        .then(
          (result) => {
            this.ngZone.run(() => {
              resolve(result);
            });
          },
          (reason) => {
            this.ngZone.run(() => {
              reject(reason);
            });
          },
        );
    }));
  }

  optIn(): void {
    OneSignalPlugin.User.pushSubscription.optIn();
  }

  optOut(): void {
    OneSignalPlugin.User.pushSubscription.optOut();
  }
}
